if (!customElements.get('starside-hero-video')) {
  customElements.define('starside-hero-video', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const videos = [...this.querySelectorAll('video')];
      const play = this.querySelector('[data-hero-video-play]');
      const label = this.querySelector('[data-hero-play-label]');
      if (!videos.length || !play || !label) return;
      this.initialized = true;
      let index = 0;
      const previous = this.querySelector('[data-hero-previous]');
      const next = this.querySelector('[data-hero-next]');
      const counter = this.querySelector('[data-hero-counter]');
      const nav = this.querySelector('.hero-playlist__nav');
      const caption = this.querySelector('[data-hero-video-caption]');
      const update = () => {
        videos.forEach((video,i) => { video.hidden = i !== index; });
        if (previous) previous.disabled = index === 0;
        if (next) next.disabled = index === videos.length - 1;
        if (caption) {caption.textContent = videos[index].dataset.videoTitle || '';caption.hidden = !caption.textContent;}
        if (counter) counter.textContent = this.dataset.counterTemplate.replace('__CURRENT__', String(index + 1));
      };
      const start = (nextVideo = false) => {
        const video = videos[index];
        const selected = index;
        label.textContent = play.dataset.playLabel;
        return video.play().catch(() => {
          if (index !== selected) return;
          label.textContent = nextVideo ? play.dataset.nextLabel : play.dataset.playLabel;
          play.hidden = false;
        });
      };
      const select = (target, autoplay = false, automatic = false) => {
        if (target < 0 || target >= videos.length || target === index) return;
        const old = videos[index];
        old.pause();
        index = target;
        const video = videos[index];
        video.volume = old.volume;
        video.muted = old.muted;
        if (video.dataset.videoSrc && !video.getAttribute('src')) {
          video.src = video.dataset.videoSrc;
          video.poster = video.dataset.videoPoster || '';
          video.load();
        }
        video.currentTime = 0;
        label.textContent = automatic ? play.dataset.nextLabel : play.dataset.playLabel;
        play.hidden = false;
        update();
        if (autoplay) start(automatic);
      };
      play.hidden = false;
      if (nav) nav.hidden = false;
      update();
      play.addEventListener('click', () => {
        videos[index].focus({ preventScroll: true });
        start();
      });
      previous?.addEventListener('click', () => {
        const active = !videos[index].paused && !videos[index].ended;
        select(index - 1, active);
        if (previous.disabled) play.focus({ preventScroll: true });
      });
      next?.addEventListener('click', () => {
        const active = !videos[index].paused && !videos[index].ended;
        select(index + 1, active);
        if (next.disabled) play.focus({ preventScroll: true });
      });
      videos.forEach((video,i) => {
        video.addEventListener('play', () => { if (i === index) play.hidden = true; });
        video.addEventListener('pause', () => { if (i === index) play.hidden = false; });
        video.addEventListener('ended', () => {
          if (i !== index) return;
          if (videos.length > 1 && this.dataset.autoAdvance === 'true') {
            select((index + 1) % videos.length, true, true);
          } else {
            label.textContent = play.dataset.replayLabel;
            play.hidden = false;
          }
        });
      });
    }
  });
}
